import { types as t } from 'mobx-state-tree';
import { ReadingTestSection } from '../../../question-data-model/TestSection/_implementations/reading-test-section.store';
import { TestSectionStore } from '../test-section.store';

export const DoTestReadingTestSection = t
  .compose(ReadingTestSection, TestSectionStore)
  .named('DoTestReadingTestSection');
